import { render, staticRenderFns } from "./HC3620Component.vue?vue&type=template&id=1d2f3e60&scoped=true&"
import script from "./HC3620Component.vue?vue&type=script&lang=js&"
export * from "./HC3620Component.vue?vue&type=script&lang=js&"
import style0 from "./HC3620Component.vue?vue&type=style&index=0&id=1d2f3e60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f3e60",
  null
  
)

export default component.exports